import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { actionCreator } from "../../../ajax";
import { Dispatch } from "redux";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/linq8acm/batteries/get";
  export const REQUEST_POST = "io/request/linq8acm/batteries/post";
  export const RESPONSE_GET = "io/response/linq8acm/batteries/get";
  export const RESPONSE_POST = "io/response/linq8acm/batteries/post";
  export const EDIT = "io/edit/linq8acm/batteries";
  export const POLL_START = "io/poll/linq8acm/batteries/start";
  export const POLL_STOP = "io/poll/linq8acm/batteries/stop";

  // ACTION INTERFACES
  type Requests = GetRequest | PostRequest;
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface PostRequest extends TAction<typeof REQUEST_POST> {
    data: Partial<State.Data>;
    post?: State.ServerRequest;
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.ServerResponse;
  }
  export interface PostResponse extends TAction<typeof RESPONSE_POST> {
    data: ErrorResponse;
  }
  export interface Edit extends TAction<typeof EDIT> {
    data: Partial<State.Battery>;
    idx: number;
  }
  export interface PollStart extends TAction<typeof POLL_START> {}
  export interface PollStop extends TAction<typeof POLL_STOP> {}

  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const postRequest = actionCreator<PostRequest>(REQUEST_POST);
  export const postResponse = actionCreator<PostResponse>(RESPONSE_POST);
  export const pollStart = actionCreator<PollStart>(POLL_START);
  export const pollStop = actionCreator<PollStop>(POLL_STOP);
  export const edit = actionCreator<Edit>(EDIT);
  export function fetchRequest(): GetRequest;
  export function fetchRequest(data: Partial<State.Data>): PostRequest;
  export function fetchRequest(data?: Partial<State.Data>): Requests {
    return data ? postRequest({ data }) : getRequest();
  }

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      edit: (idx: number, data: Partial<State.Battery>) =>
        dispatch(edit({ data, idx })),
      fetch: (data?: Partial<State.Data>) =>
        dispatch(data ? fetchRequest(data) : fetchRequest()),
      poll: (p: boolean) =>
        dispatch(p ? pollStart({ data: p }) : pollStop({ data: p }))
    };
  };
}

export default Actions;
